'use strict'

const MAP_TIPO_LIVRO = [
  {
    tipo: 'N',
    tipoSequencia: 'A', // Mapeamento de acordo com a cartilha do CNJ
    digito: 1,
    descricao: 'Nascimento'
  },
  {
    tipo: 'C',
    tipoSequencia: 'B', // Mapeamento de acordo com a cartilha do CNJ
    digito: 2,
    descricao: 'Casamento'
  },
  {
    tipo: 'CR',
    tipoSequencia: 'B-AUX', // Mapeamento de acordo com a cartilha do CNJ
    digito: 3,
    descricao: 'Casamento Religioso'
  },
  {
    tipo: 'O',
    tipoSequencia: 'C', // Mapeamento de acordo com a cartilha do CNJ
    digito: 4,
    descricao: 'Obito'
  },
  {
    tipo: 'NT',
    tipoSequencia: 'C-AUX', // Mapeamento de acordo com a cartilha do CNJ
    digito: 5,
    descricao: 'Natimorto'
  },
  {
    tipo: 'D',
    tipoSequencia: 'D', // Mapeamento de acordo com a cartilha do CNJ
    digito: 6,
    descricao: 'Registro de Proclamas'
    // Obs.: Habilitação de Casamento
  },
  {
    tipo: 'E',
    tipoSequencia: 'E', // Mapeamento de acordo com a cartilha do CNJ
    digito: 7,
    descricao: 'Demais atos relativos ao registro civil ou livro E único'
  },
  {
    tipo: 'E',
    tipoSequencia: 'E', // Mapeamento de acordo com a cartilha do CNJ
    digito: 8,
    descricao: 'Desdobrado para registro especifico das Emancipações'
  },
  {
    tipo: 'E',
    tipoSequencia: 'E', // Mapeamento de acordo com a cartilha do CNJ
    digito: 9,
    descricao: 'Desdobrado para registro especifico das Interdições'
  }
]

function listTipoLivro () {
  return MAP_TIPO_LIVRO.map((item) => {
    return item.tipo
  })
}

function livroHabCasamento () {
  const habCasamento = MAP_TIPO_LIVRO.find((item) => {
    if (item.tipo === 'D') {
      return item.tipo
    }
  })

  return habCasamento.tipo
}


function getTipoLivroByDigito (digito) {
  return MAP_TIPO_LIVRO.find((item) => item.digito === digito).tipo
}

function getTipoSequencia (tipo) {
  return MAP_TIPO_LIVRO.find((item) => item.tipo === tipo)
}
export default {
  listTipoLivro,
  livroHabCasamento,
  getTipoLivroByDigito,
  getTipoSequencia
}
